<template>
  <v-bottom-navigation
    v-model="activeTab"
    bg-color="orange-darken-1"
    class="bottom-nav d-flex d-md-none"
    color="white"
  >
    <v-btn value="/home" :ripple="false" @pointerdown="navigate('/home')">
      <v-icon>mdi-home-circle-outline</v-icon>
      <span>Inicio</span>
    </v-btn>

    <v-btn value="/marcas-mvgrupo" :ripple="false" @pointerdown="navigate('/marcas-mvgrupo')">
      <v-icon>mdi-shopping-outline</v-icon>
      <span>MVExpress</span>
    </v-btn>

    <v-btn value="/top-10" :ripple="false" @pointerdown="navigate('/top-10')">
      <v-icon>mdi-star-outline</v-icon>
      <span>TOP 10</span>
    </v-btn>

    <v-btn value="/user-info" :ripple="false" @pointerdown="navigate('/user-info')">
      <v-icon>mdi-account</v-icon>
      <span>Mi perfil</span>
    </v-btn>
  </v-bottom-navigation>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute();

const activeTab = ref(route.path);

watch(() => route.path, (path) => {
  activeTab.value = path;
});

const navigate = (path) => {
  if (route.path === path) return;
  router.push(path);
};
</script>

<style scoped>
.bottom-nav {
  padding-bottom: env(safe-area-inset-bottom) !important;
  height: calc(56px + env(safe-area-inset-bottom)) !important;
  z-index: 1005 !important;
}

.v-btn {
  touch-action: manipulation !important;
  -webkit-tap-highlight-color: transparent !important;
  user-select: none !important;
  -webkit-user-select: none !important;
}

/* Feedback visual inmediato al presionar */
.v-btn:active {
  transform: scale(0.88) !important;
  transition: transform 0.08s ease !important;
}

.v-btn:not(:active) {
  transition: transform 0.15s ease !important;
}

.v-btn:focus-visible {
  outline: none !important;
}

.v-btn :deep(.v-btn__overlay),
.v-btn :deep(.v-ripple__container) {
  display: none !important;
}

.v-btn span {
  font-size: 0.72rem;
  font-weight: 700;
  margin-top: 2px;
}
</style>
